<template>
  <div>
    <span v-for="(segment, ind) in segments" :key="ind">
      <span v-if="ind > 0" class="separator"></span>
      <span
           class="cursor-pointer thick"
           @click="$router.push(segment.link)"
           v-if="segment.link"
      >
        {{segment.title}}
      </span>
      <span class="thick" v-else>
        {{segment.title}}
      </span>
    </span>
  </div>
</template>

<style scoped lang="stylus">
  @import '~variables'
  span
    vertical-align middle
  .cursor-pointer
    color $primary
  .separator
    color $faded
    margin-right 3px
  .thick
    font-weight 500
  .separator:before
    content ">>"
</style>

<script>
export default {
  props: {
    id: String,
    lbl: String,
    withoutLink: {
      type: Boolean,
      default: false,
    },
    lastHasLink: {
      type: Boolean,
      default: false,
    },
  },
  components: { },
  computed: {
    segments() {
      const segs = [];
      const squeeze = (id, withoutLink) => {
        const article = this.$store.state.wiki.wikis[id];
        if (article) {
          if (withoutLink) {
            return { title: article.title, parent_id: article.parent_id };
          }
          return { title: article.title, link: `/wiki/${id}`, parent_id: article.parent_id };
        }
        return { title: '** Не найдено **', parent_id: 'root' };
      };
      if (this.id && (this.id !== 'root')) {
        segs[0] = squeeze(this.id, this.withoutLink);
      }
      while (segs[0] && segs[0].parent_id && (segs[0].parent_id !== 'root')) {
        segs.unshift(squeeze(segs[0].parent_id, this.withoutLink));
      }
      if (this.lbl) {
        segs.push({ title: this.lbl, link: null });
      }
      if (segs[0] && !this.lastHasLink) {
        segs[segs.length - 1].link = null;
      }
      return segs;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/article-path.vue